module.exports = __webpack_public_path__ + "static/media/printDoc.0c0cfe8c.svg";